import React, { useState } from 'react';
import Icon from '../AppIcon';
import { supabase } from '../../lib/supabase';

const DemoResetButton = ({ onReset }) => {
  const [isResetting, setIsResetting] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [result, setResult] = useState(null);

  const handleReset = async () => {
    setIsResetting(true);
    setResult(null);
    try {
      const { data, error } = await supabase?.rpc('reset_demo_data');
      if (error) {
        setResult({ success: false, message: error?.message });
      } else {
        setResult({ success: true, message: data?.message || 'Demo data reset successfully!' });
        onReset?.();
      }
    } catch (err) {
      setResult({ success: false, message: 'Reset failed. Please try again.' });
    } finally {
      setIsResetting(false);
      setShowConfirm(false);
      setTimeout(() => setResult(null), 4000);
    }
  };

  return (
    <div className="relative inline-flex flex-col items-end gap-2">
      {!showConfirm ? (
        <button
          onClick={() => setShowConfirm(true)}
          className="flex items-center gap-2 px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white text-sm font-semibold rounded-lg transition-colors shadow-sm"
        >
          <Icon name="RotateCcw" size={15} color="white" />
          Reset Demo Data
        </button>
      ) : (
        <div className="flex items-center gap-2 bg-card border border-border rounded-lg px-3 py-2 shadow-elevation-2">
          <span className="text-sm text-foreground font-medium">Reset all demo data?</span>
          <button
            onClick={handleReset}
            disabled={isResetting}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-red-500 hover:bg-red-600 disabled:bg-red-300 text-white text-xs font-semibold rounded-md transition-colors"
          >
            {isResetting ? (
              <>
                <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                Resetting...
              </>
            ) : (
              <>
                <Icon name="Check" size={12} color="white" />
                Confirm
              </>
            )}
          </button>
          <button
            onClick={() => setShowConfirm(false)}
            className="px-3 py-1.5 bg-muted hover:bg-muted/80 text-foreground text-xs font-medium rounded-md transition-colors"
          >
            Cancel
          </button>
        </div>
      )}
      {result && (
        <div className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium ${
          result?.success
            ? 'bg-green-50 text-green-700 border border-green-200' :'bg-red-50 text-red-700 border border-red-200'
        }`}>
          <Icon
            name={result?.success ? 'CheckCircle' : 'AlertCircle'}
            size={14}
            color="currentColor"
          />
          {result?.message}
        </div>
      )}
    </div>
  );
};

export default DemoResetButton;
